import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Metadatos de un permiso del catalogo (backend: PermissionCatalogItemDTO). */
export interface PermissionCatalogItem {
  name: string;
  module: string;
  action: string;
  label?: string | null;
  description?: string | null;
  supportOnly: boolean;
}

export interface RolePermissionsState {
  roles: string[];
  permissions: string[];
  rolePermissions: { [role: string]: string[] };
  catalog: PermissionCatalogItem[];
  /** Roles que la UI no debe permitir editar (p. ej. SUPPORT). */
  lockedRoles: string[];
}

export const initialState: RolePermissionsState = {
  roles: [],
  permissions: [],
  rolePermissions: {},
  catalog: [],
  lockedRoles: [],
};

export const rolePermissionsSlice = createSlice({
  name: 'rolePermissions',
  initialState,
  reducers: {
    setRolePermissions: (
      state,
      action: PayloadAction<Partial<RolePermissionsState>>,
    ) => {
      state.roles = action.payload.roles ?? [];
      state.permissions = action.payload.permissions ?? [];
      state.rolePermissions = action.payload.rolePermissions ?? {};
      state.catalog = action.payload.catalog ?? [];
      state.lockedRoles = action.payload.lockedRoles ?? [];
    },
    togglePermission: (
      state,
      action: PayloadAction<{ role: string; permission: string }>,
    ) => {
      const { role, permission } = action.payload;
      const current = state.rolePermissions[role] ?? [];
      state.rolePermissions[role] = current.includes(permission)
        ? current.filter((p) => p !== permission)
        : [...current, permission];
    },
    /** Reemplaza de golpe la lista de permisos de un rol (p. ej. "marcar todo el modulo"). */
    setRolePermissionList: (
      state,
      action: PayloadAction<{ role: string; permissions: string[] }>,
    ) => {
      const { role, permissions } = action.payload;
      state.rolePermissions[role] = Array.from(new Set(permissions));
    },
  },
});

export const { setRolePermissions, togglePermission, setRolePermissionList } =
  rolePermissionsSlice.actions;
export default rolePermissionsSlice.reducer;
